import { useState } from "react";
import PaymentAction from "./PaymentAction.ts";
import ResponseData from "../action/ResponseData.ts";
import Payment from "./Payment.ts";
function usePaymentState() {
    const [payment, setPayment] = useState<Payment | null>(null);
    const [error, setError] = useState(null);

    const loadHandler = (data: unknown) => {
        const responseData = data as ResponseData;
        if (responseData.data) {
            console.log("responseData.data", responseData.data);
            setPayment(responseData.data);
        }
    };
    const errorHandler = (error: unknown) => {
        const responseError = error as ResponseData;
        setError(responseError.error);
    };

    const updateRefund = (token: string, book_id: string, amount: number) => {
        PaymentAction.updateRefund(token, book_id, amount, loadHandler, errorHandler);
    };

    return { error, payment, updateRefund };
}

export default usePaymentState;
